import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';
import PrivacyPolicy from './PrivacyPolicy';
import DeleteAccount from './DeleteAccount';

// Custom SVG Icons
const GroupIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const AnalyticsIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
    <path d="M22 12A10 10 0 0 0 12 2v10z" />
  </svg>
);

const LockIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

const FreeIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
    <circle cx="12" cy="12" r="10" />
    <path d="M16 8h-6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H8" />
    <line x1="12" y1="6" x2="12" y2="18" />
  </svg>
);

const ReceiptIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
    <path d="M4 2v20l2-1 2 1 2-1 2 1 2-1 2 1 2-1 2 1V2l-2 1-2-1-2 1-2-1-2 1-2-1-2 1-2-1z" />
    <path d="M16 8H8" />
    <path d="M16 12H8" />
    <path d="M13 16H8" />
  </svg>
);

const WalletIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-svg">
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="M12 4v16" />
    <path d="M2 12h20" />
  </svg>
);

const PlayIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" className="play-svg">
    <polygon points="5 3 19 12 5 21 5 3" />
  </svg>
);

const PlayStoreIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="playstore-svg-icon" style={{ marginRight: '10px' }}>
    <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.61 3,21.09 3,20.5Z" fill="#00C0FF"/>
    <path d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z" fill="#FF3A44"/>
    <path d="M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.53 12.9 20.18 13.18L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81Z" fill="#FFC107"/>
    <path d="M6.05 2.66L16.81 8.88L14.54 11.15L6.05 2.66Z" fill="#00E765"/>
  </svg>
);

const StarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="#22c55e" stroke="#22c55e" strokeWidth="2" className="star-svg">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

function HomePage() {


  return (
    <div className="App">
      {/* Navbar / Header */}
      <header className="header">
        <div className="container header-container">
          <div className="logo">
            <img src="/logo.jpg" alt="SpendsMate" className="logo-img" />
            <span className="logo-text">SpendsMate</span>
          </div>
          <nav className="nav">
            <a href="#home" className="active">Home</a>
            <a href="#features">Features</a>
            <a href="#how-it-works">How It Works</a>
            <a href="#security">Security</a>
          </nav>

        </div>
      </header>

      {/* Hero Section */}
      <section id="home" className="hero-section" style={{
        backgroundImage: "url('/assets/background.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center top',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="container hero-grid">
          <div className="hero-left-content">
            <div className="badge-wrapper">
              <span className="smart-badge">
                <span className="badge-dot"></span> Smart. Simple. Shared Expenses.
              </span>
            </div>
            <h1 className="hero-title">
              Split expenses. <br />
              <span className="text-green">Stay in sync.</span>
            </h1>
            <p className="hero-subtitle">
              SpendsMate makes it easy to split bills, track spends and settle up with friends, family or groups.
            </p>
            <div className="hero-actions-row">
              <a href="https://play.google.com/store/apps/details?id=com.spendmates" target="_blank" rel="noopener noreferrer" className="get-started-btn">Get Started for Free</a>
              <a href="#how-it-works" className="how-itworks-btn">
                <PlayIcon /> See How It Works
              </a>
            </div>

            {/* 4 Feature Badges */}
            <div className="hero-feature-badges">
              <div className="hero-badge-item">
                <div className="badge-circle bg-green">
                  <GroupIcon />
                </div>
                <span>Group Expenses</span>
              </div>
              <div className="hero-badge-item">
                <div className="badge-circle bg-blue">
                  <AnalyticsIcon />
                </div>
                <span>Smart Analytics</span>
              </div>
              <div className="hero-badge-item">
                <div className="badge-circle bg-orange">
                  <LockIcon />
                </div>
                <span>Secure & Private</span>
              </div>
              <div className="hero-badge-item">
                <div className="badge-circle bg-purple">
                  <FreeIcon />
                </div>
                <span>100% Free to Use</span>
              </div>
            </div>
          </div>
          <div className="hero-right-image">
            <img src="/assets/hero-phones.png" alt="SpendsMate App Mockup" className="hero-phones-mockup" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <div className="container">
          <div className="section-header">
            <span className="section-subtitle">Everything you need to</span>
            <h2 className="section-title">manage shared expenses</h2>
          </div>
          <div className="features-cards-grid">
            <div className="feature-card-item">
              <div className="feature-card-icon-box card-icon-green">
                <GroupIcon />
              </div>
              <h3 className="feature-card-title">Create Groups</h3>
              <p className="feature-card-text">
                Add friends and create groups in seconds.
              </p>
            </div>
            <div className="feature-card-item">
              <div className="feature-card-icon-box card-icon-orange">
                <ReceiptIcon />
              </div>
              <h3 className="feature-card-title">Add Expenses</h3>
              <p className="feature-card-text">
                Add any expense and split in any way you want.
              </p>
            </div>
            <div className="feature-card-item">
              <div className="feature-card-icon-box card-icon-blue">
                <AnalyticsIcon />
              </div>
              <h3 className="feature-card-title">Track & Analyze</h3>
              <p className="feature-card-text">
                Powerful insights to help you spend smarter.
              </p>
            </div>
            <div className="feature-card-item">
              <div className="feature-card-icon-box card-icon-purple">
                <WalletIcon />
              </div>
              <h3 className="feature-card-title">Settle Up Easily</h3>
              <p className="feature-card-text">
                See who owes what and settle instantly.
              </p>
            </div>
            <div className="feature-card-item">
              <div className="feature-card-icon-box card-icon-teal">
                <LockIcon />
              </div>
              <h3 className="feature-card-title">Secure & Private</h3>
              <p className="feature-card-text">
                Your data is safe and always protected.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section" style={{
        backgroundImage: "linear-gradient(rgba(3, 7, 4, 0.9), rgba(3, 7, 4, 0.9)), url('/assets/how-works-bg.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="container">
          <div className="section-header center">
            <h2 className="section-title text-center">How It Works</h2>
          </div>
          <div className="how-it-works-flow">
            <div className="flow-connecting-line"></div>
            <div className="how-step-item">
              <div className="step-number-node">
                <div className="step-circle-icon bg-green">
                  <GroupIcon />
                </div>
                <div className="step-badge-number">1</div>
              </div>
              <h3 className="step-title">Create a Group</h3>
              <p className="step-description">
                Add your friends or create a group.
              </p>
            </div>
            <div className="how-step-item">
              <div className="step-number-node">
                <div className="step-circle-icon bg-orange">
                  <ReceiptIcon />
                </div>
                <div className="step-badge-number">2</div>
              </div>
              <h3 className="step-title">Add Expenses</h3>
              <p className="step-description">
                Add bills and split in any way.
              </p>
            </div>
            <div className="how-step-item">
              <div className="step-number-node">
                <div className="step-circle-icon bg-blue">
                  <AnalyticsIcon />
                </div>
                <div className="step-badge-number">3</div>
              </div>
              <h3 className="step-title">Track & Analyze</h3>
              <p className="step-description">
                See who owes what and track your spends.
              </p>
            </div>
            <div className="how-step-item">
              <div className="step-number-node">
                <div className="step-circle-icon bg-purple">
                  <WalletIcon />
                </div>
                <div className="step-badge-number">4</div>
              </div>
              <h3 className="step-title">Settle Up</h3>
              <p className="step-description">
                Settle up and keep everything balanced.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA / Download Section */}
      <section id="security" className="cta-download-section">
        <div className="container cta-grid">
          <div className="cta-left-content">
            <div className="badge-wrapper">
              <span className="smart-badge">Available on iOS & Android</span>
            </div>
            <h2 className="cta-title">
              Take <span className="text-green">SpendsMate</span><br />
              wherever you go
            </h2>
            <p className="cta-description">
              The easiest way to manage group expenses on the go.
            </p>

          </div>
          <div className="cta-right-image">
            <img src="/assets/cta-phones.png" alt="SpendsMate Mobile Display" className="cta-phones-img" />
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="pricing" className="testimonials-section" style={{
        backgroundImage: "linear-gradient(rgba(3, 7, 4, 0.9), rgba(3, 7, 4, 0.9)), url('/assets/reviews-bg.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}>
        <div className="container">
          <div className="section-header center">
            <span className="section-subtitle text-center">Loved by <span className="text-green font-bold">thousands</span></span>
            <h2 className="section-title text-center">of users worldwide</h2>
          </div>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <div className="stars-row">
                <StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon />
              </div>
              <p className="testimonial-text">
                "SpendsMate made our trips so much easier. No more confusion about who owes what!"
              </p>
              <span className="testimonial-author">- Priya Agnihotri</span>
            </div>
            <div className="testimonial-card">
              <div className="stars-row">
                <StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon />
              </div>
              <p className="testimonial-text">
                "Clean, simple and super helpful. The analytics feature is a game changer."
              </p>
              <span className="testimonial-author">- Sankalp Dubey</span>
            </div>
            <div className="testimonial-card">
              <div className="stars-row">
                <StarIcon /><StarIcon /><StarIcon /><StarIcon /><StarIcon />
              </div>
              <p className="testimonial-text">
                "Finally an app that keeps our group expenses organized and stress free."
              </p>
              <span className="testimonial-author">- Dev Tiwari</span>
            </div>
          </div>
        </div>
      </section>

      {/* Email Subscription CTA Banner */}
      <section className="subscribe-banner-section">
        <div className="container">
          <div className="subscribe-box">
            <div className="subscribe-grid">
              <div className="subscribe-text-side">
                <h3 className="subscribe-title">
                  Ready to simplify<br />
                  your <span className="text-green">shared expenses?</span>
                </h3>
              </div>
              <div className="subscribe-form-side" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                <a href="https://play.google.com/store/apps/details?id=com.spendmates" target="_blank" rel="noopener noreferrer" className="store-btn" style={{ display: 'inline-flex', alignItems: 'center' }}>
                  <PlayStoreIcon />
                  <span>Google Play</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer id="blog" className="footer">
        <div className="container">
          <div className="footer-top-grid">
            <div className="footer-brand-column">
              <div className="footer-logo">
                <img src="/logo.jpg" alt="SpendsMate" className="footer-logo-img" />
                <span className="footer-logo-text">SpendsMate</span>
              </div>
              <p className="footer-brand-tagline">
                Smart. Simple. Shared Expenses.
              </p>
              <div className="footer-socials">
                <a href="https://www.instagram.com/spendsmate/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                </a>
                <a href="https://www.linkedin.com/company/spendsmates" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                </a>
              </div>
            </div>
            <div className="footer-links-column">
              <h4 className="footer-links-title">Product</h4>
              <ul className="footer-links-list">
                <li><a href="#features">Features</a></li>
                <li><a href="#how-it-works">How It Works</a></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4 className="footer-links-title">Company</h4>
              <ul className="footer-links-list">
                <li><a href="mailto:support@spendsmate.com">Contact Us</a></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
              </ul>
            </div>
            <div className="footer-links-column">
              <h4 className="footer-links-title">Support</h4>
              <ul className="footer-links-list">
                <li><a href="mailto:support@spendsmate.com">support@spendsmate.com</a></li>
                <li><a href="mailto:info@spendsmate.com">info@spendsmate.com</a></li>
              </ul>
            </div>
          </div>
          <div className="footer-bottom-bar">
            <p className="footer-copyright">&copy; 2026 SpendsMate. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
      </Routes>
    </Router>
  );
}

export default App;